import { RootState } from 'redux/types';

export const getIsPeopleFromTeam = (peopleId: string, team: string) => (store: RootState) => {
  const peopleTeamId = store.people.entities[peopleId].teams[0];
  return store.teams.entities[peopleTeamId] && store.teams.entities[peopleTeamId].name === team;
};
